import { SelectValueLabel } from 'common/types/SelectValueLabel';
import Http from 'common/services/Http';
import { ExpenseTemplatesDto } from './models/ExpenseTemplatesDto';

class ExpenseTemplatesService {

    public catalog() {
        return Http.get<SelectValueLabel[]>('expensetemplates/catalog');
    }   

     public listForSupplier(supplierId: string) {
        return Http.get<ExpenseTemplatesDto[]>(`expensetemplates/list-for-supplier/${supplierId}`);
    }   
}

export default new ExpenseTemplatesService();
